import * as React from "react";

import { LOADING, asUI } from "common/components/types";
import { asArrayValue, loadedDefinedMapWithDefault, asString } from "common/components/component-helpers";
import List from "../../ui/smart/list/list";
import { GalleryListContainer } from "../../ui/deprecated/GalleryList";
import { defined } from "common/Support";
import { NumberOfColumns } from "common/generator/array-screens/number-of-columns";
import { GlideFunctionalRenderer } from "common/components/uis";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

function groupArr<T>(data: T[], n: number) {
    const group: T[][] = [];
    for (let i = 0, j = 0; i < data.length; i++) {
        if (i >= n && i % n === 0) j++;
        group[j] = group[j] || [];
        group[j].push(data[i]);
    }
    return group;
}

export const GalleryListMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[list, itemUI, numColumns]] = useForceValueProducers(getValueProducers, force, ctx);
    if (list === LOADING || itemUI === LOADING) return env.renderProgress();

    const numColumnsValue = loadedDefinedMapWithDefault(numColumns, NumberOfColumns.Three, asString) as NumberOfColumns;

    let columns: number;
    try {
        columns = Number.parseInt(numColumnsValue, 10);
    } catch {
        columns = 3;
    }

    const arr = asArrayValue(list);
    const grouped = groupArr(arr, columns);

    return (
        <List
            title=""
            topAlign={true}
            appFeatures={env.appEnvironment.appFeatures}
            key={"GalleryList" + arr.length.toString()}
            hasUnevenRows={false}
            items={grouped}>
            {(item, _i, columnWidth) => {
                const rowHeight = (defined(columnWidth) - 3) / columns;
                return (
                    <GalleryListContainer columns={columns} rowHeight={rowHeight}>
                        {item.map((image, index) => (
                            <React.Fragment key={index}>{asUI(itemUI).render(image, env)}</React.Fragment>
                        ))}
                    </GalleryListContainer>
                );
            }}
        </List>
    );
};
